import { render, staticRenderFns } from "./SLink.vue?vue&type=template&id=2eaf7c8e&scoped=true"
import script from "./SLink.vue?vue&type=script&lang=js"
export * from "./SLink.vue?vue&type=script&lang=js"
import style0 from "./SLink.vue?vue&type=style&index=0&id=2eaf7c8e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eaf7c8e",
  null
  
)

export default component.exports